import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { JournalView, getJournalOptions } from '@/module/Journal';

export const Route = createFileRoute('/_auth/journal/_journal/$journalId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { journalId } = Route.useParams();
  const { data: journal } = useSuspenseQuery(getJournalOptions(journalId));

  return <JournalView journal={journal} />;
}
